/*
 * Verticale productgalerij.
 *
 * De carousel is vervangen door foto's onder elkaar. Dit script neemt over wat
 * Flickity deed: bijhouden welke foto in beeld is, de miniaturen daarop
 * afstemmen, en bij een variantwissel naar de juiste foto springen.
 *
 * De teller telt alleen zichtbare foto's. Staat "variantbeelden verbergen"
 * aan, dan verschilt dat aantal per gekozen kleur.
 */
(function () {
  'use strict';

  var DESKTOP = '(min-width: 1068px)';

  function Galerij(root) {
    this.root = root;
    this.mediaKolom = root.querySelector('.product-images--vertical');
    this.slides = [];
    this.huidig = -1;

    if (!this.mediaKolom) return;

    this.streepjes = root.querySelector('[data-gallery-streepjes]');
    this.thumbs = root.querySelectorAll('.product-thumbnail');

    this.verzamel();
    this.koppelThumbs();
    this.volgScroll();
    this.markeer(0);
  }

  /* Alleen zichtbare slides tellen mee: verborgen variantbeelden niet. */
  Galerij.prototype.verzamel = function () {
    var alle = this.mediaKolom.querySelectorAll('.product-images__slide');
    this.slides = [];

    for (var i = 0; i < alle.length; i++) {
      if (alle[i].classList.contains('is-active')) this.slides.push(alle[i]);
    }

    this.tekenStreepjes();
  };

  /* Eén streepje per zichtbare foto. Bij een kleurwissel verandert dat aantal,
     dus bouwen we ze opnieuw op in plaats van ze vast in de opbouw te zetten. */
  Galerij.prototype.tekenStreepjes = function () {
    if (!this.streepjes) return;
    if (this.streepjes.childNodes.length === this.slides.length) return;

    this.streepjes.innerHTML = '';
    for (var i = 0; i < this.slides.length; i++) {
      var streep = document.createElement('span');
      streep.className = 'product-gallery-meta__streep';
      this.streepjes.appendChild(streep);
    }
    this.huidig = -1;
  };

  Galerij.prototype.mediaSleutel = function (el) {
    // Slide: id="Slide-<section>-<media>", thumb: id="Thumb-<section>-<media>"
    var id = el.id || '';
    var deel = id.split('-');
    return deel.length > 1 ? deel.slice(1).join('-') : id;
  };

  Galerij.prototype.koppelThumbs = function () {
    var self = this;

    for (var i = 0; i < this.thumbs.length; i++) {
      (function (thumb) {
        thumb.addEventListener('click', function (e) {
          e.preventDefault();
          var sleutel = self.mediaSleutel(thumb);

          for (var s = 0; s < self.slides.length; s++) {
            if (self.mediaSleutel(self.slides[s]) === sleutel) {
              self.springNaar(self.slides[s]);
              break;
            }
          }
        });
      })(this.thumbs[i]);
    }
  };

  Galerij.prototype.springNaar = function (slide) {
    if (!slide) return;

    var vloeiend = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (window.matchMedia(DESKTOP).matches) {
      var top = window.pageYOffset + slide.getBoundingClientRect().top;
      window.scrollTo({ top: top, behavior: vloeiend ? 'smooth' : 'auto' });
    } else {
      // Op mobiel staan de foto's naast elkaar in een veegbare rij.
      this.mediaKolom.scrollTo({
        left: slide.offsetLeft,
        behavior: vloeiend ? 'smooth' : 'auto',
      });
    }
  };

  Galerij.prototype.markeer = function (index) {
    if (index === this.huidig || index < 0) return;
    this.huidig = index;

    if (this.streepjes) {
      var strepen = this.streepjes.childNodes;
      for (var s = 0; s < strepen.length; s++) {
        if (s === index) strepen[s].classList.add('is-actief');
        else strepen[s].classList.remove('is-actief');
      }
    }

    var actief = this.slides[index];
    var sleutel = actief ? this.mediaSleutel(actief) : null;

    for (var i = 0; i < this.thumbs.length; i++) {
      var thumb = this.thumbs[i];
      thumb.classList.toggle('is-current', sleutel !== null && this.mediaSleutel(thumb) === sleutel);
    }
  };

  Galerij.prototype.volgScroll = function () {
    var self = this;

    if (!('IntersectionObserver' in window)) return;

    // De foto die het dichtst bij het midden van het scherm staat, geldt als
    // de huidige. Een enkele drempel zou bij hoge foto's te vroeg omslaan.
    this.observer = new IntersectionObserver(
      function (entries) {
        var beste = null;
        var besteRatio = 0;

        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio > besteRatio) {
            besteRatio = entry.intersectionRatio;
            beste = entry.target;
          }
        });

        if (!beste) return;

        var index = self.slides.indexOf(beste);
        if (index !== -1) self.markeer(index);
      },
      { threshold: [0.25, 0.5, 0.75] }
    );

    for (var i = 0; i < this.slides.length; i++) this.observer.observe(this.slides[i]);
  };

  /* Na een variantwissel kan de set zichtbare foto's veranderd zijn. */
  Galerij.prototype.herzie = function (mediaId) {
    if (this.observer) this.observer.disconnect();

    this.verzamel();
    this.huidig = -1;
    this.volgScroll();

    if (mediaId) {
      for (var i = 0; i < this.slides.length; i++) {
        if (this.slides[i].id.indexOf('-' + mediaId) !== -1) {
          this.springNaar(this.slides[i]);
          this.markeer(i);
          return;
        }
      }
    }

    this.markeer(0);
  };

  /* ----------------------------------------------------------------------
   * Prijs in de koopknop gelijk houden aan de gekozen variant.
   *
   * Het thema herrendert bij een variantwissel een vaste set elementen, en de
   * koopknop hoort daar niet bij. Het prijsblok wél — daar nemen we het bedrag
   * uit over, zodat opmaak van valuta en kortingen het werk van Liquid blijft.
   * -------------------------------------------------------------------- */

  function koppelPrijsAanKnop(root) {
    var knopPrijs = root.querySelector('.single-add-to-cart-button--price');
    if (!knopPrijs) return;

    var priceEl = null;
    var kandidaten = root.querySelectorAll('[id^="price-"]');
    for (var i = 0; i < kandidaten.length; i++) {
      if (kandidaten[i].id.indexOf('--sticky') === -1) {
        priceEl = kandidaten[i];
        break;
      }
    }
    if (!priceEl) return;

    var sync = function () {
      // <ins> bevat de actuele prijs; <del> is de doorgestreepte adviesprijs.
      var actueel = priceEl.querySelector('ins .amount') || priceEl.querySelector('.amount');
      var bedrag = actueel ? actueel.textContent.trim() : '';
      if (bedrag && bedrag !== knopPrijs.getAttribute('data-content')) {
        knopPrijs.setAttribute('data-content', bedrag);
      }
    };

    new MutationObserver(sync).observe(priceEl, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    sync();
  }

  /* ----------------------------------------------------------------------
   * Vangnet voor de koopknop na een maatwissel.
   *
   * De variantlogica van het thema schakelt bij elke wissel eerst de knop uit
   * en pas na afloop weer in. Breekt die keten onderweg af, dan blijft de knop
   * uitgeschakeld staan en kan er niets meer in het mandje — ook niet de maat
   * die daarvoor nog wel werkte. In updateMedia() staat bijvoorbeeld een
   * aanroep zonder controle op een ontbrekend element.
   *
   * Deze code leidt de gekozen variant zelf af uit de aangevinkte opties,
   * herstelt de knopstatus en zet het juiste variant-id in het formulier.
   * Werkt de logica van het thema wel, dan doet dit hetzelfde nog eens —
   * zonder bijwerking.
   * -------------------------------------------------------------------- */

  function variantUitOpties(root) {
    var json = root.querySelector('script[type="application/json"]');
    if (!json) return null;

    var data;
    try {
      data = JSON.parse(json.textContent);
    } catch (e) {
      return null;
    }
    if (!Array.isArray(data)) return null;

    var gekozen = [];
    var velden = root.querySelectorAll('fieldset');
    for (var i = 0; i < velden.length; i++) {
      var aan = velden[i].querySelector('input:checked');
      var keuze = velden[i].querySelector('select');
      if (aan) gekozen.push(aan.value);
      else if (keuze) gekozen.push(keuze.value);
    }
    if (!gekozen.length) return null;

    for (var v = 0; v < data.length; v++) {
      var opties = data[v].options || [];
      var raak = opties.length === gekozen.length;
      for (var o = 0; raak && o < opties.length; o++) {
        if (opties[o] !== gekozen[o]) raak = false;
      }
      if (raak) return data[v];
    }
    return null;
  }

  /* ----------------------------------------------------------------------
   * CRO 14: de knop volgt de keuze
   *
   * Bij het laden staat er geen maat voorgeselecteerd. Zolang niet elke optie
   * gekozen is, toont de koopknop "Select your size" en voegt hij niets toe.
   * Zodra alles gekozen is, zetten we het variant-id in het formulier, zetten
   * we de knop op "Add to cart" en komt de variant in de URL te staan.
   *
   * We houden hiervoor geen eigen kopie van de staat bij: de aangevinkte
   * opties in <variant-selects> zijn de waarheid, net als bij het thema zelf.
   * -------------------------------------------------------------------- */

  function alleOptiesGekozen(root) {
    var velden = root.querySelectorAll('fieldset');
    for (var i = 0; i < velden.length; i++) {
      var aan = velden[i].querySelector('input:checked');
      var keuze = velden[i].querySelector('select');
      if (!aan && !(keuze && keuze.value)) return false;
    }
    return velden.length > 0;
  }

  function koopknoppen() {
    return document.querySelectorAll('#AddToCart, #AddToCartSticky');
  }

  /* Welke optie is nog niet gekozen? Daarmee kan de knop zeggen wát er mist.
     Bij meerdere kleuren is dat anders dan bij de maat: iemand die lengte en
     wijdte al koos, snapt "Select your size" niet meer. */
  function ontbrekendeVelden(root) {
    var velden = root.querySelectorAll('fieldset');
    var uit = [];
    for (var i = 0; i < velden.length; i++) {
      var aan = velden[i].querySelector('input:checked');
      var keuze = velden[i].querySelector('select');
      if (!aan && !(keuze && keuze.value)) uit.push(velden[i]);
    }
    return uit;
  }

  function eersteOntbrekendeVeld(root) {
    return ontbrekendeVelden(root)[0] || null;
  }

  function kiesLabelVoor(knop, veld) {
    var handle = (veld && veld.dataset.handle) || '';
    if (/colou?r|kleur|farbe/i.test(handle) && knop.dataset.kiesKleurLabel) {
      return knop.dataset.kiesKleurLabel;
    }
    return knop.dataset.kiesLabel;
  }

  function zetLabel(knop, tekst) {
    var span = knop.querySelector('[data-content]');
    if (span && tekst) span.dataset.content = tekst;
    if (tekst) knop.setAttribute('aria-label', tekst);
  }

  function wachtOpKeuze(knop, veld) {
    knop.classList.add('kies-maat');
    knop.setAttribute('aria-disabled', 'true');
    knop.removeAttribute('disabled');
    zetLabel(knop, kiesLabelVoor(knop, veld));
  }

  function klaarVoorKopen(knop, variant) {
    knop.classList.remove('kies-maat');
    knop.removeAttribute('aria-disabled');

    if (variant.available) {
      knop.removeAttribute('disabled');
      knop.classList.remove('sold-out', 'loading');
      zetLabel(knop, knop.dataset.koopLabel);
    } else {
      knop.setAttribute('disabled', 'disabled');
      knop.classList.add('sold-out');
    }
  }

  function nietsOpVoorraad(root) {
    var json = root.querySelector('script[type="application/json"]');
    if (!json) return false;
    try {
      var data = JSON.parse(json.textContent);
    } catch (e) {
      return false;
    }
    if (!Array.isArray(data) || !data.length) return false;
    for (var i = 0; i < data.length; i++) {
      if (data[i].available) return false;
    }
    return true;
  }

  /* ----------------------------------------------------------------------
   * CRO 13: welke maten zijn nog te krijgen?
   *
   * Beschikbaarheid hangt af van de combinatie. Staat Length 32 vast, dan
   * telt voor elke Width alleen de voorraad bij die length. We kijken dus per
   * optie naar de andere gekozen opties en laten die ene optie los.
   *
   * Het thema heeft hier zelf setDisabled() voor, maar dat werkt pas als er
   * al een volledige variant gekozen is — precies wat we sinds punt 14 niet
   * meer doen. Daarom rekenen we het hier zelf uit.
   * -------------------------------------------------------------------- */

  function variantenUit(root) {
    var json = root.querySelector('script[type="application/json"]');
    if (!json) return null;
    try {
      var data = JSON.parse(json.textContent);
    } catch (e) {
      return null;
    }
    return Array.isArray(data) ? data : null;
  }

  function gekozenWaarden(root) {
    var velden = root.querySelectorAll('fieldset');
    var uit = [];
    for (var i = 0; i < velden.length; i++) {
      var aan = velden[i].querySelector('input:checked');
      var keuze = velden[i].querySelector('select');
      uit.push(aan ? aan.value : keuze && keuze.value ? keuze.value : null);
    }
    return uit;
  }

  /* ----------------------------------------------------------------------
   * De variantfoto bij een nog onvolledige keuze.
   *
   * Het thema wisselt de foto op product:variant-change, en dat signaal komt
   * er pas als alle opties gekozen zijn. Sinds punt 14 staat de maat niet
   * meer voor, dus op een product met Color + Width + Length gebeurde er na
   * een kleurklik niets. We zoeken daarom zelf de eerste variant die bij de
   * tot nu toe gekozen waarden hoort en pakken diens foto.
   *
   * Kies je alleen een maat, dan blijft dit dezelfde foto als die al in beeld
   * staat: de eerste variant met die maat hoort bij de eerste kleur.
   * -------------------------------------------------------------------- */

  function mediaBijKeuze(root) {
    var data = variantenUit(root);
    if (!data) return null;

    var gekozen = gekozenWaarden(root);
    var iets = false;
    for (var g = 0; g < gekozen.length; g++) if (gekozen[g]) iets = true;
    if (!iets) return null;

    for (var i = 0; i < data.length; i++) {
      var opties = data[i].options || [];
      var raak = true;
      for (var o = 0; o < gekozen.length; o++) {
        if (gekozen[o] && opties[o] !== gekozen[o]) {
          raak = false;
          break;
        }
      }
      if (raak && data[i].featured_media) return data[i].featured_media.id;
    }
    return null;
  }

  function toonFotoBijKeuze(root) {
    var mediaId = mediaBijKeuze(root);
    if (!mediaId) return;

    toonVariantfoto(mediaId);
    if (galerijen) {
      for (var i = 0; i < galerijen.length; i++) galerijen[i].herzie(mediaId);
    }
  }

  function werkBeschikbaarheidBij(root) {
    var data = variantenUit(root);
    if (!data) return;

    var gekozen = gekozenWaarden(root);
    var velden = root.querySelectorAll('fieldset');

    for (var i = 0; i < velden.length; i++) {
      var inputs = velden[i].querySelectorAll('input[type="radio"]');

      for (var k = 0; k < inputs.length; k++) {
        var waarde = inputs[k].value;
        var tekoop = false;

        for (var v = 0; v < data.length && !tekoop; v++) {
          if (!data[v].available) continue;
          var opties = data[v].options || [];
          if (opties[i] !== waarde) continue;

          // De overige opties moeten kloppen met wat de klant al koos.
          var past = true;
          for (var o = 0; o < gekozen.length && past; o++) {
            if (o === i || gekozen[o] === null) continue;
            if (opties[o] !== gekozen[o]) past = false;
          }
          if (past) tekoop = true;
        }

        var label = inputs[k].id
          ? root.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(inputs[k].id) : inputs[k].id) + '"]')
          : null;
        if (!label) continue;

        label.classList.toggle('maat-uitverkocht', !tekoop);

        var naam = inputs[k].value;
        inputs[k].setAttribute(
          'aria-label',
          tekoop ? naam : naam + ' — ' + (root.dataset.uitverkochtLabel || 'sold out')
        );
      }
    }
  }

  /* ----------------------------------------------------------------------
   * Uitverkochte maat gekozen: Klaviyo neemt het over.
   *
   * De app-embed van Klaviyo kijkt zelf naar de gekozen variant, verbergt de
   * koopknop van het thema en zet er zijn eigen knop neer. Wij bouwen daar
   * geen tweede formulier naast; de sticky balk krijgt hetzelfde label en
   * klikt bij een tik gewoon die knop aan.
   * -------------------------------------------------------------------- */

  function klaviyoKnop() {
    return document.querySelector('[data-a11y-identifier^="bis-button"]');
  }

  function stickyNaarKlaviyo() {
    var balkknop = document.getElementById('Sticky-Toggle');
    if (!balkknop || balkknop.dataset.bisGekoppeld) return;
    balkknop.dataset.bisGekoppeld = '1';

    balkknop.addEventListener(
      'click',
      function (gebeurtenis) {
        if (balkknop.dataset.bisActief !== '1') return;
        var knop = klaviyoKnop();
        if (!knop) return;
        gebeurtenis.preventDefault();
        gebeurtenis.stopPropagation();
        knop.click();
      },
      true
    );
  }

  function herstelKoopknop(root) {
    var knoppen = koopknoppen();

    werkBeschikbaarheidBij(root);
    toonFotoBijKeuze(root);
    stickyNaarKlaviyo();

    // Is het hele product uitverkocht, dan valt er niets te kiezen: de knop
    // blijft op "Sold out" staan zoals Liquid hem heeft gerenderd, met de
    // Klaviyo-knop ernaast.
    if (nietsOpVoorraad(root)) return;

    var compleet = alleOptiesGekozen(root);
    var variant = compleet ? variantUitOpties(root) : null;
    var form = document.getElementById('product-form-' + root.dataset.section);
    var idVeld = form ? form.querySelector('input[name="id"]') : null;

    if (!variant) {
      if (idVeld) idVeld.value = '';
      // Alleen benoemen wat er mist als dat één ding is. Ontbreekt er meer,
      // dan is "Select your size" de duidelijkste eerste stap.
      var missend = ontbrekendeVelden(root);
      var ontbreekt = missend.length === 1 ? missend[0] : null;
      for (var n = 0; n < knoppen.length; n++) wachtOpKeuze(knoppen[n], ontbreekt);

      // De balk leest zijn label hiervandaan, dus die moet meeveranderen.
      var balk = document.getElementById('Sticky-Toggle');
      if (balk) {
        balk.dataset.bisActief = '0';
        balk.dataset.kiesLabel = kiesLabelVoor(balk, ontbreekt) || balk.dataset.kiesLabel;
      }
      return;
    }

    // Het formulier moet het juiste variant-id meesturen.
    if (idVeld) idVeld.value = variant.id;

    for (var i = 0; i < knoppen.length; i++) klaarVoorKopen(knoppen[i], variant);

    // De balk vertelt hetzelfde als de knop in de pagina.
    var balkknop = document.getElementById('Sticky-Toggle');
    if (balkknop) balkknop.dataset.bisActief = variant.available ? '0' : '1';

    // De URL noemt de variant, zodat delen en herladen de keuze bewaren.
    if (root.dataset.updateUrl !== 'false' && window.history && history.replaceState) {
      history.replaceState({}, '', (root.dataset.url || location.pathname) + '?variant=' + variant.id);
    }
  }


  /*
   * Klikt iemand toch op de knop zonder maat, dan sturen we hem naar de
   * maatkiezer in plaats van niets te doen.
   */
  function naarMaatkiezer() {
    var root = document.querySelector('variant-selects:not([data-sticky])');
    var veld = root ? eersteOntbrekendeVeld(root) : null;

    // Valt er niets aan te wijzen, dan pakken we de eerste echte keuze.
    if (!veld) {
      veld = document.querySelector(
        '.product-information--inner fieldset.product-form__input:not(.product-form__input--vast)'
      );
    }
    if (!veld) return;

    veld.scrollIntoView({ block: 'center', behavior: 'smooth' });
    veld.classList.add('vraagt-aandacht');
    setTimeout(function () {
      veld.classList.remove('vraagt-aandacht');
    }, 1600);
  }

  document.addEventListener(
    'click',
    function (event) {
      var knop = event.target.closest
        ? event.target.closest('#AddToCart, #AddToCartSticky')
        : null;
      if (!knop || knop.getAttribute('aria-disabled') !== 'true') return;

      event.preventDefault();
      event.stopPropagation();

      // In het sticky venster staat de maatkiezer al in beeld; daar volstaat
      // de aandachtsmarkering zonder te scrollen.
      var inVenster = knop.closest('.product-add-to-cart-sticky-modal');
      if (inVenster) {
        var vensterRoot = inVenster.querySelector('variant-selects');
        var veld = (vensterRoot && eersteOntbrekendeVeld(vensterRoot)) ||
          inVenster.querySelector('fieldset.product-form__input:not(.product-form__input--vast)');
        if (veld) {
          veld.classList.add('vraagt-aandacht');
          setTimeout(function () {
            veld.classList.remove('vraagt-aandacht');
          }, 1600);
        }
        return;
      }

      naarMaatkiezer();
    },
    true
  );

  // Laatste slot: zonder variant-id mag er niets verstuurd worden.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
      var idVeld = form.querySelector('input[name="id"]');
      if (idVeld && !idVeld.value) {
        event.preventDefault();
        event.stopPropagation();
        naarMaatkiezer();
      }
    },
    true
  );

  // Eén keer bij het laden, zodat knop, formulier en URL kloppen met wat er
  // daadwerkelijk aangevinkt staat (bijvoorbeeld na terugkeer met ?variant=).
  function beginstand() {
    var roots = document.querySelectorAll('variant-selects:not([data-sticky])');
    for (var i = 0; i < roots.length; i++) herstelKoopknop(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', beginstand);
  } else {
    beginstand();
  }

  document.addEventListener(
    'change',
    function (event) {
      var doel = event.target;
      if (!doel || !doel.closest) return;

      var root = doel.closest('variant-selects');
      if (!root) return;

      // Even wachten tot het thema klaar is met zijn eigen afhandeling.
      setTimeout(function () {
        herstelKoopknop(root);
      }, 150);
    },
    true
  );

  var galerijen = [];

  function init() {
    galerijen = [];
    var roots = document.querySelectorAll('.product-gallery--vertical');
    for (var i = 0; i < roots.length; i++) galerijen.push(new Galerij(roots[i]));

    var rasters = document.querySelectorAll('.product-grid--vertical');
    for (var r = 0; r < rasters.length; r++) koppelPrijsAanKnop(rasters[r]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  /* ----------------------------------------------------------------------
   * De foto van de gekozen kleur zichtbaar maken.
   *
   * Staat de thema-instelling "variantfoto's verbergen" aan, dan rendert
   * Liquid alleen de foto van de gekozen variant met `is-active`; de andere
   * variantfoto's staan op display:none. Het thema wisselt die class in
   * setActiveMedia() om — maar dat stuk draait alleen als de Flickity-
   * carrousel bestaat, en die hebben wij vervangen door verticaal scrollen.
   * Daardoor bleef bij een kleurwissel dezelfde foto staan. We zetten de
   * class daarom zelf, precies zoals Liquid het bij het laden doet:
   * alleen variantfoto's schakelen, gewone foto's blijven altijd staan.
   * -------------------------------------------------------------------- */
  function hoortBij(element, mediaId) {
    var staart = '-' + mediaId;
    return element.id && element.id.slice(-staart.length) === staart;
  }

  function toonVariantfoto(mediaId) {
    if (!mediaId) return;

    // Alleen waar het thema variantfoto's verbergt; anders staat alles al aan.
    var houders = document.querySelectorAll('[data-hide-variants="true"]');

    for (var h = 0; h < houders.length; h++) {
      var items = houders[h].querySelectorAll('.product-images__slide-item--variant');
      for (var i = 0; i < items.length; i++) {
        var raak = hoortBij(items[i], mediaId);
        // is-initial-selected hoort erbij: de miniaturenbalk toont een miniatuur
        // zodra hij is-active OF is-initial-selected heeft. Die tweede class
        // bleef op de eerste miniatuur staan, waardoor er na een kleurwissel
        // twee miniaturen zichtbaar waren.
        if (raak) {
          items[i].classList.add('is-active');
          items[i].classList.add('is-initial-selected');
        } else {
          items[i].classList.remove('is-active');
          items[i].classList.remove('is-initial-selected');
        }
      }
    }
  }

  document.addEventListener('product:variant-change', function (event) {
    var detail = event.detail || {};
    var mediaId = detail.variant && detail.variant.featured_media
      ? detail.variant.featured_media.id
      : null;

    // De slides krijgen hun is-active class van het thema; even wachten tot
    // die verwerkt is voordat we opnieuw tellen.
    setTimeout(function () {
      toonVariantfoto(mediaId);
      for (var i = 0; i < galerijen.length; i++) galerijen[i].herzie(mediaId);
    }, 60);
  });
})();
